import React, { useState } from 'react';

const BelongingsSettingsEditor = ({ belongingsMaster, setBelongingsMaster }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [newItem, setNewItem] = useState('');

    const addItem = () => {
        if (!newItem.trim()) return;
        setBelongingsMaster([...belongingsMaster, newItem.trim()]);
        setNewItem('');
    };

    const removeItem = (index) => {
        const newItems = [...belongingsMaster];
        newItems.splice(index, 1);
        setBelongingsMaster(newItems);
    };

    return (
        <div style={{marginBottom:'20px', border:'1px solid #ddd', borderRadius:'8px', background:'white', overflow:'hidden'}}>
            <div onClick={() => setIsOpen(!isOpen)} style={{padding:'15px', background:'#f5f5f5', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', fontWeight:'bold'}}>
                <span>🎒 持ち物リスト設定 ({belongingsMaster.length})</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div style={{padding:'15px'}}>
                    <div style={{fontSize:'11px', color:'#666', marginBottom:'10px'}}>
                        イベント作成時に選択できる「持ち物」の選択肢を登録します。
                    </div>
                    <div style={{display:'flex', gap:'5px', marginBottom:'10px'}}>
                        <input type="text" value={newItem} onChange={e=>setNewItem(e.target.value)} placeholder="例: スパイク" style={{flex:1}} />
                        <button onClick={addItem} className="btn btn-sm btn-primary">追加</button>
                    </div>
                    <div style={{display:'flex', flexWrap:'wrap', gap:'5px'}}>
                        {belongingsMaster.map((item, i) => (
                            <span key={i} style={{background:'#e3f2fd', padding:'5px 10px', borderRadius:'15px', fontSize:'12px', display:'flex', alignItems:'center'}}>
                                {item} <span onClick={()=>removeItem(i)} style={{marginLeft:'5px', cursor:'pointer', color:'#d32f2f', fontWeight:'bold'}}>×</span>
                            </span>
                        ))}
                        {belongingsMaster.length === 0 && <span style={{fontSize:'11px', color:'#999'}}>登録なし</span>}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BelongingsSettingsEditor;